import React, { Component } from 'react';
import DOMPurify from 'dompurify';

export default class DocumentHtmlView extends Component {

    render() {
        var clean = DOMPurify.sanitize(this.props.html);

        return (
            <div className="document-html" dangerouslySetInnerHTML={{ __html: clean }} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DocumentViewer/DocumentHtmlView.js